// Pricing is display-only here. Incomplete responses must never invent a charge.
export const formatMembershipPrice = pricing => {
  if (!pricing || typeof pricing !== 'object' || Array.isArray(pricing)
      || typeof pricing.currency !== 'string' || !/^[a-z]{3}$/i.test(pricing.currency)
      || !Number.isSafeInteger(pricing.amount_cents) || pricing.amount_cents <= 0) return null;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: pricing.currency.toUpperCase(),
      minimumFractionDigits: 0, maximumFractionDigits: 2,
    }).format(pricing.amount_cents / 100);
  } catch {
    return null;
  }
};